import { useContext } from 'react';
import { OptimizelyContext, useDecision } from '@optimizely/react-sdk';
import { HOTEL_DINING_CAROUSEL_FLAG_KEY } from '../../experiment-registry';

export function useHotelDiningCarousel(): { enabled: boolean } {
	const { optimizely } = useContext(OptimizelyContext);

	if (!optimizely) return { enabled: false };

	const [decision, clientReady] = useDecision(HOTEL_DINING_CAROUSEL_FLAG_KEY, {
		autoUpdate: true,
	});
	return { enabled: clientReady && (decision?.enabled ?? false) };
}
